import { FC, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { TreeItem } from "./types";
import { TreeViewList } from "./TreeViewList";
import { Skeleton } from "../../../../components/loading";

interface TreeViewProps {
  id: string;
  inputText: string;
  isLoading: boolean;
  items: TreeItem[];
  onClick: (item: TreeItem) => void;
}

export const TreeView: FC<TreeViewProps> = (props) => {
  const [searchCriteria, setSearchCriteria] = useState("");

  const handleSearchCriteriaChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchCriteria(event.target.value);
  };

  return (
    <Stack id={props.id} height="100%">
      <Box p={2}>
        <TextField
          fullWidth
          id={`${props.id}-input-search`}
          label={props.inputText}
          type="search"
          value={searchCriteria}
          onChange={handleSearchCriteriaChange}
        />
      </Box>

      <Skeleton isLoading={props.isLoading} height="100%">
        <TreeViewList
          filter={searchCriteria}
          items={props.items}
          onItemSelect={props.onClick}
        />
      </Skeleton>
    </Stack>
  );
};
